import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './auth/authConfig';
import { setMsalInstance } from './services/api';
import App from './App';

const msalInstance = new PublicClientApplication(msalConfig);

// Wait for MSAL to initialize, handle redirect response, then set instance
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then(() => {
    setMsalInstance(msalInstance as any);
  }).catch(console.error);
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);
